var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"ma-0 pa-0"},[_c('hero',{attrs:{"title":"Awards"}}),_c('v-row',{staticClass:"ma-1"},_vm._l((24),function(n){return _c('v-col',{key:n,class:{
        custom2cols: _vm.$vuetify.breakpoint.xs,
        custom5cols: _vm.$vuetify.breakpoint.smAndUp
      }},[_c('v-img',{staticClass:"bg-grey-lighten-2",attrs:{"alt":_vm.awards[23-n],"src":("/images/awards/award_" + (25-n) + ".png"),"aspect-ratio":"1","cover":""}})],1)}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }